import { Box, Container, Link, Stack, Typography } from '@mui/material';

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'primary.contrastText',
        py: { xs: 4, md: 5 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
          }}
        >
          <Stack spacing={0.5}>
            <Typography
              variant="overline"
              sx={{ color: 'rgba(245, 241, 232, 0.7)', letterSpacing: '0.2em' }}
            >
              Growth Focus Solutions
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(245, 241, 232, 0.85)', fontFamily: '"Playfair Display", serif' }}
            >
              Coach with Logan
            </Typography>
          </Stack>

          <Stack direction="row" spacing={3} sx={{ alignItems: 'center' }}>
            <Link
              href="https://www.linkedin.com/in/logan-a-white"
              underline="hover"
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'rgba(245, 241, 232, 0.8)', fontSize: '0.9rem' }}
            >
              LinkedIn
            </Link>
            <Link
              href="#contact"
              underline="hover"
              color="inherit"
              sx={{ color: 'rgba(245, 241, 232, 0.8)', fontSize: '0.9rem' }}
            >
              Contact
            </Link>
          </Stack>
        </Stack>

        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: { xs: 3, sm: 4 },
            color: 'rgba(245, 241, 232, 0.5)',
            fontSize: '0.78rem',
          }}
        >
          © {new Date().getFullYear()} Growth Focus Solutions LLC. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
